(function () {
  'use strict';

  angular
    .module('audio.audioCtrl', [
      'audio.audioDirective',
      'factories.playerControls',
      'factories.utils',
      'factories.navigationFactory'
    ])
    .controller('AudioCtrl', AudioCtrl);

  AudioCtrl.$inject = ['$scope', '$timeout', 'PlayerControls', 'Utils', 'Navigation', '$rootScope',
    'FrameStateProgressHelper', 'MobileHelper', 'Sension'];

  function AudioCtrl($scope, $timeout, PlayerControls, Utils, Navigation, $rootScope,
                     FrameStateProgressHelper, MobileHelper, Sension) {
    var states = { playing: 'playing', paused: 'paused', scrubbing: 'scrubbing', ended: 'ended', starting: 'starting' };
    var currentSlide;
    var audioState;
    var audioControl;
    var isTrackingProgress = false;

    $rootScope.isMuted = $rootScope.isMuted || false;
    $scope.playerControls = PlayerControls;
    $scope.pausedWhileEngaged = false;
    $scope.deferredSeekTime = null;
    $scope.canPlay = false;
    $scope.bufferedPercent = 0;
    $scope.hasPlayed = false;

    $scope.onReady = function () {
      $scope.audio5jsPlayer = this;
      $scope.audio5jsPlayer.load(audioState.audioSrc);

      $scope.audio5jsPlayer.on('play', function (e) {
        if (!$scope.hasPlayed) {
          $scope.hasPlayed = true;
          // Set volume to whatever setting was on previous slide.
          $scope.setVolume();
        }

        if (!audioState.state || audioState.state == states.paused || audioState.state == states.ended || audioState.state == states.starting) {
          // Media controls, etc. need to know it's playing.
          audioControl.play();
        }

        if (Sension.enabled()) {
          // Ensure this is asyncronous so that there's not an apply in progress.
          $timeout(function () {
            Sension.mediaPlaying(audioControl.getCurrentTime());
          }, 1);
        }
      });

      $scope.audio5jsPlayer.on('pause', function (e) {
        $scope.pausedWhileEngaged = Sension.isEngaged();
        audioControl.pause();
        if (Sension.enabled()) {
          // Ensure this is asyncronous so that there's not an apply in progress.
          $timeout(function () {
            Sension.mediaPaused(audioControl.getCurrentTime());
          }, 1);
        }
      });

      $scope.audio5jsPlayer.on('progress', function (percent) {
        if (percent >= 99)
          percent = 100; // we don't seem to ever get above 99% which looks stupid so just call it 100%.
        $scope.bufferedPercent = percent / 100;
      });

      $scope.audio5jsPlayer.on('canplay', function () {
        $scope.onReadyToStartPlaying();
        $scope.canPlay = true;

        $scope.checkIfCanModifyVolume();

        // No need to track progress anymore if they've previously seen the entire audio.
        $scope.calculateTrackProgress();
        isTrackingProgress = false;

        if (audioControl.trackProgress) {
          isTrackingProgress = true;
          FrameStateProgressHelper.setup({
            cModuleId: $scope.cModuleId,
            frameId: audioControl.slide.id,
            initialProgress: audioControl.slide.progressSeconds
          }, audioControl.getCurrentTime);

          if (audioControl.slide.progressSeconds > 0)
            $scope.seekToProgress();
        }

        if ($scope.deferredSeekTime) {
          audioControl.seek($scope.deferredSeekTime);
          $scope.deferredSeekTime = null;
        }

        if (!MobileHelper.isMobileDevice() || MobileHelper.isNativeIpadApp) {
          if (Sension.enabled()) {
            Sension.mediaSetup({
              identifier: audioControl.slide.id,
              duration: Math.ceil(audioControl.getDuration())
            });

            if (Sension.isEngaged())
              audioControl.play();
            else
              audioControl.pause();
          } else {
            audioControl.play();
          }
        } else if (MobileHelper.isTouch()) {
          audioControl.pause();
        }
      });

      $scope.audio5jsPlayer.on('error', function (err) {
        setTimeout(function () {
          console.error('Audio onerror: ' + Utils.stringifyOnce(err));
          $rootScope.$apply();
        }, 500);
      });
    };

    $scope.onError = function (err) {
      $timeout(function () {
        console.error('Audio error: ' + Utils.stringifyOnce(err));
      }, 1);
    };

    $scope.reloadHandler.reload = function () {
      if (audioState)
        $scope.$apply(function () {
          audioState.state = states.paused;
        });
    };

    $scope.calculateTrackProgress = function () {
      if (!audioControl.getCurrentTime || !audioControl.getDuration)
        return;

      audioControl.slide.progressSeconds = Math.max(audioControl.slide.progressSeconds, Math.floor(audioControl.getCurrentTime()));
      audioControl.trackProgress = !$scope.isPreview && !$scope.completionInfo &&
        //audioControl.slide.status != 117000200 /*Completed*/ &&
        (audioControl.getDuration() - 1) > audioControl.slide.progressSeconds &&
        (Navigation.slideIndex == (Navigation.numUnlockedSlides - 1)) &&
        Navigation.playerType == Navigation.playerTypes.trainee;
    };

    $scope.onReadyToStartPlaying = function () {
      Navigation.state = Navigation.states.ready;
      if (MobileHelper.isTouch() && (!MobileHelper.isNativeIpadApp) || !MobileHelper.isMobileHeight()) {
        PlayerControls.slideControlsVisible = true;
        PlayerControls.resetControlsTimer();
      }
    };

    $scope.checkIfCanModifyVolume = function () {
      // We already know whether they can mute so quit.
      if (typeof $rootScope.canMute == 'boolean' || !$scope.audio5jsPlayer)
        return;

      var volume = $scope.audio5jsPlayer.volume();
      if (volume <= .9) {
        $scope.audio5jsPlayer.volume(volume + 0.1);
        $rootScope.canMute = ($scope.audio5jsPlayer.volume() == volume + 0.1);
        $scope.audio5jsPlayer.volume(volume);
      } else {
        $scope.audio5jsPlayer.volume(volume - 0.1);
        $rootScope.canMute = ($scope.audio5jsPlayer.volume() == volume - 0.1);
        $scope.audio5jsPlayer.volume(volume);
      }
    };

    $scope.setVolume = function () {
      if (!$scope.audio5jsPlayer) return;

      if ($rootScope.isMuted)
        $scope.audio5jsPlayer.volume(0);
      else
        $scope.audio5jsPlayer.volume(1);
    };

    $scope.seekToProgress = function () {
      $timeout(function () {
        if (audioControl.getCurrentTime() < (audioControl.slide.progressSeconds - 2)) {
          audioControl.seek(audioControl.slide.progressSeconds);
          $scope.seekToProgress();
        }
      }, 50);
    };

    $scope.$watch('currentSlide', function () {
      if (!$scope.currentSlide) return;

      currentSlide = $scope.currentSlide;
      audioState = $scope.mediaState = {
        audioSrc: '',
        currentTime: 0,
        duration: 0,
        state: states.starting,
        states: states
      };

      audioControl = $scope.mediaControl = {
        isPreview: $scope.isPreview,
        slide: currentSlide,
        canPlay: function () {
          return $scope.canPlay;
        },
        getBufferedPercent: function () {
          return $scope.bufferedPercent;
        },
        getCurrentTime: function () {
          var currentTime = 0;
          if ($scope.audio5jsPlayer) {
            // Try to get from the HTML5 audio element as it gives a smoother progress bar.
            if ($scope.audio5jsPlayer.audio.audio && $scope.audio5jsPlayer.audio.audio.currentTime)
              currentTime = $scope.audio5jsPlayer.audio.audio.currentTime;
            else
              currentTime = $scope.audio5jsPlayer.position;
          }
          return currentTime;
        },
        getDuration: function () {
          var duration = 0;
          if ($scope.audio5jsPlayer) {
            if ($scope.audio5jsPlayer.audio.audio && $scope.audio5jsPlayer.audio.audio.duration)
              duration = $scope.audio5jsPlayer.audio.audio.duration;
            else
              duration = $scope.audio5jsPlayer.audio.duration;
            duration = duration ? duration - 0.2 : 0;
          }
          return duration;
        },
        haveEnoughData: function () {
          return $scope.canPlay;
        },
        rawPause: function () {
          if ($scope.audio5jsPlayer && $scope.audio5jsPlayer.playing)
            $scope.audio5jsPlayer.pause();
        },
        rawPlay: function () {
          if ($scope.audio5jsPlayer && !$scope.audio5jsPlayer.playing)
            $scope.audio5jsPlayer.play();
        },
        rawSeek: function (time) {
          if (isNaN(parseFloat(time))) return;
          if (!$scope.audio5jsPlayer) return;

          if (!$scope.hasPlayed) {
            $scope.deferredSeekTime = time;
            audioControl.play();
          } else {
            $scope.audio5jsPlayer.seek(time);
          }
        },
        toggleMute: function () {
          if (!$scope.audio5jsPlayer) return;
          $rootScope.isMuted = !$rootScope.isMuted;
          $scope.setVolume();
        }
      };
    });

    $scope.$watch('mediaState.state', function (state) {
      Navigation.showNavControls = (state === states.paused || state === states.ended || state === states.starting);
    });

    $scope.$on('sensionIsEngagedChanged', function () {
      if (!Sension.enabled() || !audioControl || !audioControl.play || !audioControl.pause)
        return;

      // Pause any time use isn't engaged if we're requiring engagement. Otherwise just pause when we
      // can't find their face as in this case we assume they've walked away.
      if (!$scope.pausedWhileEngaged && !Sension.faceHidden() && (!Sension.requireEngagement() || Sension.isEngaged())) {
        audioControl.play();
      } else if (Sension.requireEngagement() || Sension.faceHidden()) {
        audioControl.pause();
      }
    });

    $scope.$on('$destroy', function () {
      if (audioControl && audioControl.pause) {
        audioControl.pause();
      }

      if (isTrackingProgress) {
        $scope.calculateTrackProgress();
        FrameStateProgressHelper.updateProgress();
      }
      FrameStateProgressHelper.destroy();

      if ($scope.audio5jsPlayer && $scope.audio5jsPlayer.off) {
        $scope.audio5jsPlayer.off('canplay');
        $scope.audio5jsPlayer.off('pause');
        $scope.audio5jsPlayer.off('play');
        $scope.audio5jsPlayer.off('progress');
        $scope.audio5jsPlayer.off('error');
      }

      $scope.audio5jsPlayer = null;
    });

    Navigation.intercept('navigate', function interceptNavigate(navigateTo) {
      if (navigateTo === Navigation.directions.next && (audioState.state === states.paused || audioState.state === states.starting)) {
        audioState.state = states.playing;
        return false;
      }
      return true;
    });
  }
})();